const map = L.map("map").setView([21.17128044628222, 106.06725264262127], 50);

L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
	attribution: "© OpenStreetMap contributors",
}).addTo(map);

const specificLocation = [21.17128044628222, 106.06725264262127];
L.marker(specificLocation)
	.addTo(map)
	.bindPopup("Parkview City - Dabaco Huyền Quang")
	.openPopup();
const img1 = new URL(
	"../assets/Images/KT-off5/sai-lam-xuyen-the-he.png",
	import.meta.url,
);
const img2 = new URL(
	"../assets/Images/KT-off5/nguoi-bo-nong-tinh-va-hanh-trinh-chua-lanh-cam-xuc.jpg",
	import.meta.url,
);
const img3 = new URL(
	"../assets/Images/KT-off5/con-gian-cua-me-la-noi-djau-cua-con.jpg",
	import.meta.url,
);
const img4 = new URL(
	"../assets/Images/KT-off5/tuoi-day-thi-va-su-bat-luc-cua-nguoi-me.png",
	import.meta.url,
);
const img5 = new URL(
	"../assets/Images/KT-off5/song-canh-con-ma-nhu-nguoi-xa-la.jpg",
	import.meta.url,
);
const img6 = new URL(
	"../assets/Images/KT-off5/me-ap-dat-lam-ton-thuong-con.jpg",
	import.meta.url,
);
const img7 = new URL(
	"../assets/Images/KT-off5/me-chinh-la-niem-tu-hao.jpg",
	import.meta.url,
);

const img8 = new URL("../assets/Chua_lanh_cam_xuc_k4.jpg", import.meta.url);

const img9 = new URL(
	"../assets/hoc_cach_binh_tinh_va_thau_hieu_con.jpg",
	import.meta.url,
);
const img10 = new URL("../assets/duong_den_tai_tim_con.jpg", import.meta.url);
const img11 = new URL(
	"../assets/song_mot_cuoc_doi_man_nguyen.jpg",
	import.meta.url,
);

const img12 = new URL(
	"../assets/Images/KT-offk6/me_binh_an_dong_hanh_cung_con.jpg",
	import.meta.url,
);

const img13 = new URL(
	"../assets/Images/KT-offk6/tu_tuyet_vong_den_hanh_phuc.jpg",
	import.meta.url,
);

const img14 = new URL(
	"../assets/Images/KT-offk6/khi_yeu_thuong_dung_cach.jpg",
	import.meta.url,
);

const img15 = new URL(
	"../assets/Images/KT-offk6/diem_khoi_phat.jpg",
	import.meta.url,
);

const img16 = new URL(
	"../assets/Images/KT-offk6/khong_be_tac_khong_do_loi.jpg",
	import.meta.url,
);

const img17 = new URL(
	"../assets/Images/KT-offk6/day_con_yeu_thuong_thau_hieu.jpg",
	import.meta.url,
);

const img18 = new URL(
	"../assets/Images/KT-offk6/me_nhut_nhat.jpg",
	import.meta.url,
);

const img19 = new URL(
	"../assets/Images/KT-offk6/me_on_con_on.jpg",
	import.meta.url,
);

const img20 = new URL(
	"../assets/Images/KT-offk6/su_hoa_hop.jpg",
	import.meta.url,
);

const img21 = new URL(
	"../assets/Images/KT-off-k7/trinh-thi-quynh.jpg",
	import.meta.url,
);
const img22 = new URL(
	"../assets/Images/KT-off-k7/cao-quang-hieu.jpg",
	import.meta.url,
);
const img23 = new URL(
	"../assets/Images/KT-off-k7/truong-thi-phuong-hai.jpg",
	import.meta.url,
);
const img24 = new URL(
	"../assets/Images/KT-off-k7/anh-chau-chi-dung.jpg",
	import.meta.url,
);
const img25 = new URL(
	"../assets/Images/KT-off-k7/Chi_Ngoc_anh_Hung.jpg",
	import.meta.url,
);

const thumbK1 = new URL("../assets/Thumb-K1.jpg", import.meta.url);
const thumbK2 = new URL("../assets/Thumb-K2.jpg", import.meta.url);
const thumbK3 = new URL("../assets/Thumb-K3.jpg", import.meta.url);
const thumbK4 = new URL("../assets/Thumb-K4.jpg", import.meta.url);
const thumbK5 = new URL("../assets/Images/KT-offk6/KTO-5.jpg", import.meta.url);
const thumbK6 = new URL(
	"../assets/Images/KT-offk6/KTOFF-6.jpg",
	import.meta.url,
);

const thumbK7 = new URL(
	"../assets/Images/KT-off-k7/KTOFF-7.jpg",
	import.meta.url,
);

const thumbK8 = new URL(
	"../assets/Images/KT-off-k9/KT-OFF-8.png",
	import.meta.url,
);

const slideContentExperience = [
	{
		title: "TỪ “VỎ BỌC” BÌNH AN ĐẾN HẠNH PHÚC TRỌN VẸN! ",
		description: `
        Nhìn từ bên ngoài, gia đình anh Nguyễn Văn Hùng và chị Lê Thị Bích Ngọc (Hà Nội) từng là hình mẫu mà ai cũng ngưỡng mộ: bình an, hạnh phúc. Nhưng đằng sau lớp “vỏ bọc” ấy lại là khoảng cách, những khúc mắc khó giải tỏa, đặc biệt trong mối quan hệ với cậu con trai út.
				Trong lúc tưởng chừng bế tắc, anh chị đã tìm đến cô Lanh và Học viện Minh Trí Thành. Ban đầu chỉ là sự khởi xướng của chị Ngọc, nhưng bất ngờ thay, chính anh Hùng lại là người học tập say mê và thay đổi mạnh mẽ hơn cả. Chỉ sau một tuần, sự chuyển hóa đã hiện rõ, như một món quà xứng đáng cho nỗ lực của anh chị.
				Làm thế nào mà một gia đình tưởng chừng “ổn” lại tìm thấy hạnh phúc thật sự? Điều gì đã giúp họ phá bỏ lớp vỏ bọc để kiến tạo một cuộc sống trọn vẹn?
        `,
		videoSrc:
			"https://landing-page-assets.hcm.ss.bfcplatform.vn/KienTaoOff/Videos/nguyen-van-hung-ngo-thi-bich-ngoc.mp4",
		thumb: img25,
	},
	{
		title: "2 - 3 ngày vui rồi lại 4 - 5 ngày buồn…",
		description: `
        Gia đình anh Châu và chị Dung (Hồ Chí Minh) từng rơi vào vòng lặp căng thẳng ấy.
				Người chồng có lúc không chịu nổi phải bỏ đi… Người vợ nóng tính, thường xuyên đổ lỗi…
				Không khí gia đình ngột ngạt, con ngày càng mất kết nối với bố mẹ, hạnh phúc gia đình đứng bên bờ vực tan vỡ.
 				Bước ngoặt đến khi cả hai vợ chồng biết đến cô Lanh cùng Minh Trí Thành. Từ những kiến thức cô chia sẻ, anh chị đã áp dụng và dần tìm lại sự ấm áp, tiếng cười và niềm tin vào nhau.
				Đây không chỉ là câu chuyện của riêng gia đình anh Châu và chị Dung, mà cũng là lời nhắc cho rất nhiều gia đình: Nếu một lần can đảm thay đổi, hạnh phúc có thể bắt đầu lại từ đầu.
        `,
		videoSrc:
			"https://landing-page-assets.hcm.ss.bfcplatform.vn/KienTaoOff/Videos/vo-chong-nguyen-ngoc-dung-le-anh-chau.mp4",
		thumb: img24,
	},
	{
		title: "Con Nhút Nhát Và Hành Trình Đồng Hành Của Người Mẹ Giúp Con Thêm Tự Tin",
		description: `
        Trước khi gặp cô Lanh và Minh Trí Thành, chị Trương Thị Phương Hải luôn lo lắng vì con quá nhút nhát, tự ti, việc gì cũng phải có bố mẹ bên cạnh mới dám làm.
				Chị từng lo sợ rằng con sẽ lớn lên thiếu tự lập, thiếu bản lĩnh giữa cuộc đời.
				Nhưng rồi, khi được một người bạn giới thiệu vào hành trình "Chữa lành" và "Nâng Tầm" cùng cô Lanh và Minh Trí Thành, mọi thứ dần thay đổi: Con biết tự tin nói ra điều mình nghĩ, biết tự làm, tự chịu trách nhiệm và quan trọng nhất – mối quan hệ giữa hai mẹ con ngày càng gắn kết.
        `,
		videoSrc:
			"https://landing-page-assets.hcm.ss.bfcplatform.vn/KienTaoOff/Videos/truong-thi-phuong-hai.mp4",
		thumb: img23,
	},
	{
		title: "TỪ LƯỚT QUA NHAU NHƯ NGƯỜI LẠ... ĐẾN HẠNH PHÚC VIÊN MÃN!",
		description: `
        Đã có lúc, anh Hiếu và vợ gần như trở thành người xa lạ… Những xung đột trong cách nuôi dạy con, khác biệt trong văn hóa gia đình và những tổn thương sâu trong lòng vợ khiến mối quan hệ vợ chồng rơi vào khủng hoảng, tưởng chừng không thể cứu vãn.
				Họ từng nghĩ đến việc buông tay… Nhưng kết quả đã thay đổi khi chị Thu - vợ anh Hiếu biết đến các chương trình chia sẻ của cô Lanh và Minh Trí Thành. Từ những ngày lạnh lùng, xa cách, hai vợ chồng dần học được cách lắng nghe - thấu hiểu và yêu thương trở lại.
				Tình yêu được hàn gắn, gia đình thêm gắn bó, sự nghiệp khởi sắc và điều ngọt ngào nhất - họ chào đón thêm một thiên thần nhỏ.
				Câu chuyện của gia đình anh Hiếu khiến ta tin rằng: Chỉ cần còn yêu, mọi vết nứt đều có thể hàn gắn. Và đôi khi, hạnh phúc lại bắt đầu … từ chính giây phút ta chịu mở lòng. 
        `,
		videoSrc:
			"https://landing-page-assets.hcm.ss.bfcplatform.vn/KienTaoOff/Videos/cao-quang-hieu.mp4",
		thumb: img22,
	},
	{
		title: "Hành Trình Chữa Lành Của Một Người Mẹ",
		description: `
        “Mẹ đền lại cho con cái bàn tay này đi…”
				Câu nói khiến chị Quỳnh sụp đổ - nhưng cũng chính là khởi đầu cho hành trình chữa lành và yêu thương trở lại.
				Có lẽ ít ai tin rằng, người mẹ từng khiến con trai gãy tay trong một lần cắt tóc, từng bế tắc và dằn vặt trong cảm giác tội lỗi lại có thể trở thành một người mẹ bình an, một người vợ hạnh phúc như hôm nay. 
				Câu chuyện của chị Quỳnh không chỉ là hành trình chữa lành của một người mẹ, mà là tấm gương của sự chuyển hóa – khi người phụ nữ dám thay đổi, cả gia đình sẽ được chữa lành.
        `,
		videoSrc:
			"https://landing-page-assets.hcm.ss.bfcplatform.vn/KienTaoOff/Videos/trinh-thi-quynh.mp4",
		thumb: img21,
	},
	{
		title: "Đỉnh cao của cuộc đời là sự hòa hợp",
		description: `
        “Trước đây, mỗi lần vợ chồng xảy ra bất hòa, có khi phải mất cả tháng, thậm chí 1-2 tháng mới làm lành được. Nhưng từ khi có trong tay những kiến thức quý giá, được thầy cô hướng dẫn các quy trình cụ thể, thì mọi thứ đã thay đổi. Giờ đây, chỉ cần 1-2 ngày là mình đã có thể tháo gỡ khúc mắc và hàn gắn mối quan hệ.”
				Anh Vũ Ngọc Lân - trước kia là người rất ít nói chuyện với con. Hai bố con chỉ trao đổi khi thật sự cần thiết. Trong cuộc sống, anh cũng thường nghiêm khắc, hay mắng con, và cảm thấy khó hòa hợp với những người xung quanh.
				Nhưng rồi bước ngoặt đến khi anh biết đến chương trình “Đường đến trái tim con” của cô Lanh. Và tham gia các buổi học và trải nghiệm thực tế tại chương trình Kiến Tạo Offline, anh Lân dần thay đổi từ bên trong – từ suy nghĩ đến hành động.
        `,
		videoSrc:
			"https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/videos/su_hoa_hop.mp4",
		thumb: img20,
	},
	{
		title: "Khi mình ổn thì con mình ổn",
		description: `
        Khi mình ổn, thì con mình mới ổn. 
				Khi mình an toàn, thì con mình mới an toàn. 
				Chị Hải Yến (Bắc Ninh) từng trải qua một quãng thời gian căng thẳng kéo dài. Ngày đi làm, tối về cứ gặp con là chị lại cáu giận, la mắng. Con càng lớn càng hay cãi lại, khiến hai mẹ con ngày càng xa cách. Chị lo lắng, bất lực và không biết phải dạy con thế nào cho đúng.
				Cho đến khi chị quyết định đi tìm giải pháp cho gia đình mình. Nhờ biết đến cô Lanh và tham gia chương trình "Kiến Tạo Cuộc Đời Mới" chị mới vỡ òa khi nhận ra: "Vấn đề không phải ở con, mà ở chính mình."
        `,
		videoSrc:
			"https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/videos/me_on_con_on.mp4",
		thumb: img19,
	},
	{
		title: "Người mẹ nhút nhát học cách yêu thương con",
		description: `
        Chị Bùi Thị Thanh (Hà Nội) - một người mẹ từng sống trong sự rụt rè, thiếu tự tin và chưa từng thật sự biết cách yêu thương chính mình. Trong hành trình làm mẹ, chị cũng từng áp đặt con, không biết cách ghi nhận hay lắng nghe con đúng nghĩa.
				Nhưng mọi thứ bắt đầu thay đổi…Khi chị biết đến cô Lanh và tham gia chương trình "Đường Đến Trái Tim Con" - một cánh cửa mới đã mở ra. Không chỉ học cách nuôi dạy con đúng cách, mà quan trọng hơn, chị học được cách quay về yêu thương và chữa lành chính mình. Lần thứ 2 đến với chương trình "Kiến Tạo Cuộc Đời Mới", chị Thanh mong muốn học thêm và có thêm bước tiến sâu sắc trong hành trình làm mẹ - làm người.
        `,
		videoSrc:
			"https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/videos/me_nhut_nhat.mp4",
		thumb: img18,
	},
	{
		title: "Nuôi dạy con bằng sự thấu hiểu và yêu thương",
		description: `
        Là một giáo viên và với mong muốn con lớn lên theo đúng chuẩn mực, anh đã lựa chọn cách nuôi dạy theo kiểu kiểm soát, nghiêm khắc và áp đặt. Mỗi khi con xem điện thoại, chơi game hay chưa chủ động trong học tập, anh thường trách mắng, so sánh và phê bình con gay gắt.
				Nhưng càng nghiêm khắc, con càng phản kháng. Mối quan hệ cha - con dần trở nên căng thẳng và xa cách. Dù dạy dỗ được hàng trăm học sinh mỗi năm, nhưng chính với con ruột của mình, anh lại cảm thấy bất lực…
				Mọi thứ chỉ thật sự thay đổi khi anh bước vào hành trình “Đường Đến Trái Tim Con” và “Kiến Tạo Cuộc Đời Mới”. Tại đây, anh đã biết được nguyên nhân sâu xa đằng sau những hành vi chưa tốt của con: không phải vì con “hư” mà vì con đang cần được thấu hiểu.
        `,
		videoSrc:
			"https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/videos/day_con_yeu_thuong_thau_hieu.mp4",
		thumb: img17,
	},
	{
		title: "Không còn bế tắc không còn đổ lỗi",
		description: `
        Vượt hơn 5.000km với gần 12 giờ bay - Chị Chu Thị Kim Phượng trở về từ Úc để tìm lại chính mình tại “Kiến Tạo Cuộc Đời Mới - Đường Về Hạnh Phúc K5”.
				Không còn là người phụ nữ thường xuyên cảm thấy bế tắc, dễ tổn thương trong các mối quan hệ và chưa từng thật sự hiểu rõ bản thân, chị Phượng giờ đây đã thay đổi hoàn toàn.
				Tại hành trình này, chị đã có một bước ngoặt lớn - khi nhận ra rằng: Mọi vấn đề không đến từ ai khác, mà chính từ bên trong mình. Và cũng chính tại đây, chị đã được Khai Minh Tâm Trí để thật sự thấu hiểu chính mình, thấu hiểu lý do mình có mặt trong cuộc đời này và kiến tạo cho mình những mối quan hệ tốt đẹp.
				Giờ đây, chị Phượng không chỉ giúp chính mình hạnh phúc hơn, mà còn lan tỏa điều đó đến gia đình và những người xung quanh.
        `,
		videoSrc:
			"https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/videos/khong_be_tac_khong_do_loi.mp4",
		thumb: img16,
	},
	{
		title: "“Chỉ cần MÌNH THAY ĐỔI - mọi thứ xung quanh sẽ thay đổi.”",
		description: `
        Đó là điều chị Trần Thị Ngân Hà (Phú Thọ) nhận ra sau khi tham gia chương trình Kiến Tạo Cuộc Đời Mới - Đường Về Hạnh Phúc. Từ một người thường xuyên đổ lỗi, mệt mỏi, bế tắc trong các mối quan hệ, chị Hà đã lột xác ngoạn mục từ suy nghĩ, công việc, đến cuộc sống gia đình và những mối quan hệ xung quanh. 
				Vậy hành trình đó bắt đầu từ đâu? Và chị Hà đã làm cách nào để có những kết quả tuyệt vời đến vậy?
				Mời anh chị cùng lắng nghe câu chuyện đầy cảm hứng của chị Hà qua video dưới đây để có những bài học cho riêng mình.
        `,
		videoSrc:
			"https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/videos/diem_khoi_phat.mp4",
		thumb: img15,
	},
	{
		title: "Từ nỗi đau thương đến kết nối - từ tuyệt vọng đến hạnh phúc",
		description: `
					"Mẹ có biết điều khiến con đau lòng nhất là gì không? Là mẹ cứ đưa con đi hết bác sĩ tâm lý này đến bác sĩ khác… nhưng mẹ vẫn không thật sự hiểu con, không biết con thực sự muốn gì." - Đó là những lời khiến chị Nguyễn Hoàng Yến (hiện đang sống tại Đức) như nghẹt thở khi nghe con trai mình chia sẻ, sau một khoảng thời gian dài hai mẹ con không thể kết nối với nhau.
					Chị Yến từng rất bối rối và lo lắng khi con có những biểu hiện khó kiểm soát cảm xúc, dễ nổi giận, thu mình và mất kết nối với mẹ. Dù chị đã tìm mọi cách: đưa con đi gặp nhiều chuyên gia, tìm đến các phương pháp trị liệu… nhưng tất cả đều không mang lại kết quả bền vững.
					Cho đến khi chị biết đến cô Lanh và tham gia chương trình Kiến Tạo Cuộc Đời Mới - Đường Về Hạnh Phúc. Tại đây, chị không chỉ biết được nguyên nhân đằng sau những hành vi của con, học cách lắng nghe con đúng cách - mà quan trọng hơn, chị học cách chữa lành và chuyển hóa chính mình. 
        `,
		videoSrc:
			"https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/videos/tu_dau_thuong_den_ket_noi.mp4",
		thumb: img13,
	},
	{
		title: "Mẹ bình an để đồng hành cùng con",
		description: `
          Lần đầu tiên đến với chương trình “Kiến Tạo Cuộc Đời Mới - Đường Về Hạnh Phúc”, chị Nguyễn Thị Thu Hiền (Hà Nội) mang trong mình một khát khao sâu sắc: thay đổi bản thân và chữa lành chính mình để có thể dẫn dắt con tốt hơn. Bởi vì chị hiểu rằng chỉ khi bên trong mình đủ bình an và minh triết, chị mới có thể thật sự thấu hiểu, đồng hành và trở thành người dẫn dắt tin cậy trên hành trình trưởng thành của con.
        `,
		videoSrc:
			"https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/videos/me_binh_an_dong_hanh_cung_con.mp4",
		thumb: img12,
	},
	{
		title: "Bí quyết xây dựng và kiến tạo gia đình hạnh phúc!",
		description: `
          Chị Hương Trà, đến từ Hà Nội, ban đầu tham gia chương trình "Kiến Tạo Cuộc Đời Mới – Đường Về Hạnh Phúc" chỉ vì tò mò, khi được chồng tặng vé. Điều khiến chị bất ngờ là, người chồng quen thuộc hàng ngày sau một thời gian lắng nghe những chia sẻ từ cô Lanh bỗng trở nên khác biệt - anh thấu hiểu hơn, quan tâm hơn và yêu thương gia đình một cách tự nhiên, chân thành hơn rất nhiều.
					Chứng kiến sự thay đổi rõ rệt ấy, chị Trà bắt đầu nhận ra rằng đây không chỉ là một chương trình học, mà còn là cơ hội để gia đình mình bước sang một trang mới đầy ý nghĩa. Từ sự tò mò ban đầu, chị và chồng quyết định tiếp tục đồng hành và học hỏi sâu hơn qua các chương trình khác của cô Lanh.
					Vậy điều gì đã thực sự chạm đến trái tim chị Trà, khiến gia đình chị sẵn sàng thay đổi và chuyển mình tích cực như vậy? Hãy cùng lắng nghe câu chuyện truyền cảm hứng và những chia sẻ chân thành từ chị Trà qua video dưới đây, để rút ra những bài học quý giá trong hành trình xây dựng và gìn giữ hạnh phúc gia đình.
        `,
		videoSrc:
			"https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/bi-quyet-song-mot-cuoc-doi-man-nguyen-cau-chuyen-chuyen-hoa.mp4",
		thumb: img11,
	},
	{
		title: "Con nghiện game, bỏ học và con Đường Đến Trái Tim Con!",
		description: `
          Chị Phạm Thị Anh Xuân từng rơi vào cảm giác bất lực và tuyệt vọng khi chứng kiến con trai mình ngày càng rơi vào tình trạng n.ghiện g.ame nặng: Con chơi game suốt ngày, bỏ bê việc học, không trò chuyện với bố mẹ.
					Chị đã cố gắng khuyên răn, cấm đoán, thậm chí tức giận, nhưng mọi thứ dường như chỉ khiến khoảng cách giữa hai mẹ con ngày càng xa hơn. Chị bất lực, không còn biết cách nào để giúp con thoát khỏi game và trở lại cuộc sống bình thường.
					Trong lúc đi tìm giải pháp, chị Xuân biết đến chương trình “Đường Đến Trái Tim Con” của cô Lanh và Học Viện Minh Trí Thành. Tại đây chị đã nhận ra rằng: mọi vấn đề của con đều không phải là do con mà đều xuất phát từ chị.
					Câu chuyện của chị Xuân không chỉ là hành trình của riêng chị, mà còn là bài học quý giá cho bất kỳ cha mẹ nào đang loay hoay trong việc THẤU HIỂU - ĐỒNG HÀNH và DẪN DẮT con trưởng thành.
        `,
		videoSrc:
			"https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/duong-den-trai-tim-con.mp4",
		thumb: img10,
	},
	{
		title: "Cha mẹ thay đổi - Con trưởng thành!",
		description: `
          Chị Quỳnh tìm đến với cô Lanh và học viện Minh Trí Thành thông qua chương trình "Đường Đến Trái Tim Con" trong lúc cảm thấy bế tắc với việc nuôi dạy con. Trước đây, vợ chồng chị luôn dạy con theo bản năng, dùng sự áp đặt, la mắng để răn dạy, thậm chí tin rằng "con hư là phải đánh". Nhưng càng lớn, các con càng trở nên xa cách, ít chia sẻ và thu mình lại.
					Vậy hành trình thay đổi tư duy và phương pháp nuôi dạy con của chị Quỳnh đã thay đổi như thế nào? Điều gì giúp chị chuyển hóa từ một người mẹ hay nóng giận thành người mẹ biết lắng nghe và đồng hành cùng con? 
					Qua câu chuyện của chị Quỳnh, chúng ta nhận thấy rằng mỗi bậc cha mẹ đều có thể trở thành điểm khởi phát cho sự phát triển của con, chỉ cần ta sẵn sàng học cách thấu hiểu và dẫn dắt con đúng cách!
        `,
		videoSrc:
			"https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/hoc-cach-binh-tinh-va-thau-hieu-con-bi-quyet-tro-thanh-cha-me-thong-thai-cau-chuyen-chuyen-hoa.mp4",
		thumb: img9,
	},
	{
		title: "Hành trình chữa lành cảm xúc",
		description: `
          Từ nhỏ, chị Mộng Lan đã lớn lên trong một gia đình thiếu vắng sự đầm ấm, nơi ba lạnh lùng còn tình yêu thương dường như chỉ là điều xa xỉ. Dẫu thương mẹ, chị vẫn giữ trong lòng mà không dám nói ra, chỉ mải mê với những thú vui riêng. Nhưng tất cả đã thay đổi sau khi chị cùng mẹ tham gia chương trình Kiến tạo OFF. Tại đây, chị không chỉ nhẹ lòng hơn mà còn dũng cảm ôm mẹ từ sâu thẳm trái tim – một khoảnh khắc trọn vẹn yêu thương mà chị luôn ao ước. Với chị, đó chính là hạnh phúc lớn lao nhất!  
        `,
		videoSrc:
			"https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/hanh-trinh-chua-lanh.mp4",
		thumb: img8,
	},
	{
		title: "Tuổi dậy thì và sự bất lực từ người mẹ",
		description: `
          Trong một ngôi nhà nhỏ, tình yêu từng được nuôi dưỡng bằng những bữa cơm ấm áp và nụ cười rạng rỡ. Người mẹ, với trái tim rộng lớn và đôi bàn tay đã từng nghĩ rằng mình có thể che chở và bảo vệ tất cả những đứa con mình yêu thương, dù cho không phải cùng chung dòng máu.<br />
  Nhưng thời gian trôi đi, sáu đứa con nuôi ngày nào giờ đã trưởng thành, và theo cách của riêng mình, họ đang dần rời xa. Căn nhà ngày trước từng tràn ngập tiếng cười, giờ đây trở nên yên lặng đến nghẹn ngào.<br />
  Dù khoảng cách có lớn dần, mẹ vẫn tin rằng tình yêu của một người mẹ có thể hàn gắn mọi vết thương. Đôi khi, người mẹ phải biết chờ đợi, hy vọng, và tiếp tục yêu, ngay cả khi những đứa con đang bận rộn đi tìm con đường của riêng mình trong cuộc sống rộng lớn và đầy những khó khăn!
        `,
		videoSrc:
			"https://cdn.nguyenthilanh.com.vn/resources/landing-page/LƯƠNG HUỲNH KHẢ ÁI.mp4",
		thumb: img4,
	},
	{
		title: "Vô tình gây tổn thương cho con nhiều năm mà cha mẹ không biết",
		description: `
          "Ôi! Mình đã vô tình khiến con mình tổn thương..."<br />
  Đây là lời thú nhận đầy xót xa của cô Đỗ Thị Thu Chiến - đến từ Hồ Chí Minh, khi nhớ lại khoảng thời gian tưởng chừng như không thể nào gỡ rối được mối quan hệ với con trai lớn của mình.<br />
  Hai mẹ con ngày càng khó trò chuyện, không khí lúc nào cũng căng thẳng. Cảm giác bực bội, thất vọng cứ chất chứa trong lòng, làm cho khoảng cách giữa họ càng thêm xa cách.<br />
  Cô Chiến từng không hiểu tại sao mọi thứ lại trở nên như vậy, cho đến khi cô tìm ra lời giải đáp từ những kiến thức mà cô Lanh chia sẻ. Những gì cô khám phá được đã khiến cô giật mình nhận ra nguyên nhân sâu xa của vấn đề là điều mà cô chưa từng nghĩ đến.
        `,
		videoSrc:
			"https://cdn.nguyenthilanh.com.vn/resources/landing-page/ĐỖ THỊ THU CHIẾN.mp4",
		thumb: img1,
	},
	{
		title: "Người cha nóng tính và hành trình chữa lành cảm xúc",
		description: `
          Anh Phan Hoàng Nhẫn - người từng chìm đắm trong những suy nghĩ tiêu cực, luôn phán xét mọi vấn đề trong công việc và cuộc sống, dễ nóng nảy, hay cáu gắt vô cớ với vợ con. Dù khao khát nuôi dạy con đúng cách, nhưng anh vẫn không thoát khỏi vòng xoáy của những cảm xúc tiêu cực, liên tục làm tổn thương những người thân mà chính anh hết mực yêu thương.<br />
  Trong anh luôn đau đáu một câu hỏi: "Tại sao mình yêu thương gia đình đến thế, nhưng lại luôn khiến họ đau lòng, xa cách?"
  Hành trình thay đổi của anh Nhẫn bắt đầu từ chính khoảnh khắc anh đối diện với câu hỏi ấy. Đến với cô Lanh và học viện Minh Trí Thành, anh đã tìm thấy con đường giúp bản thân thức tỉnh. Hành trình Kiến tạo offline tháng 10 vừa qua tại Hà Nội đã mở ra cho anh và gia đình một bước ngoặt mới. Những thay đổi đã dần xuất hiện, từng hành động nhỏ được thực hiện hàng ngày với tình yêu thương và nhận thức sâu sắc hơn.
        `,
		videoSrc:
			"https://cdn.nguyenthilanh.com.vn/resources/landing-page/HOÀNG NHẪN.mp4",
		thumb: img2,
	},
	{
		title: "Cơn giận của mẹ làm tổn thương con",
		description: `
          “Lần đầu tiên mình biết nói những lời yêu thương, xin lỗi với con.”
  Đó là lời tâm sự đầy xúc động của chị Liên khi đến vớ hành trình "Kiến Tạo Cuộc Đời Mới - Đường Về Hạnh Phúc" K3.<br />
  Trước đây, với nỗi lo con cái đến tuổi dậy thì sẽ học theo những thói hư và hành vi chưa tốt của nhau, chị Liên đã nhiều lần không kiềm chế được cảm xúc, hay nổi nóng và dạy con bằng đòn roi. Chị tin rằng cách dạy con này sẽ giúp con hiểu nhanh và ngoan hơn. Thế nhưng, sau mỗi lần như vậy, chị lại cảm thấy khoảng cách giữa mình và con ngày một xa dần.<br />
  Mãi cho đến khi biết đến cô Lanh và học viện Minh Trí Thành, lắng nghe những kiến thức cô chia sẻ chị Liên mới dần nhận ra rằng những cách dạy con trước đây hoàn toàn là cách nuôi dạy của những cha mẹ “độc hại”. Hiểu được điều đó, chị bắt đầu hành trình thay đổi bản thân. Từ những hành động nhỏ hằng ngày, chị học cách kiềm chế, lắng nghe, và chia sẻ để trở thành một người mẹ thấu hiểu và dẫn dắt con bằng tình yêu thương thực sự.
        `,
		videoSrc:
			"https://cdn.nguyenthilanh.com.vn/resources/landing-page/HOÀNG THỊ KIM LIÊN.mp4",
		thumb: img3,
	},

	{
		title: "Sống mất phương hướng - Lãnh cảm với chồng - Mất kết nối với con",
		description: `
          Sau nhiều năm hôn nhân, chị Huyền dần đánh mất sự kết nối với chồng và con gái – những người chị yêu thương nhất. Từ một gia đình hạnh phúc, giờ chỉ còn là một gia đình với không khi ngột ngạt, đầy những lời trách móc.<br />
  Suốt một thời gian dài, chị và chồng đã tìm mọi cách để cứu vãn, từ các cuộc trò chuyện đến các giải pháp cải thiện hôn nhân, nhưng tất cả đều không mang lại kết quả. Đến khi vợ chồng quyết định chia tay, chị mới nhận ra sự thay đổi đến đau lòng của con gái: Từ một học sinh giỏi, hoạt bát, con trở nên sống khép kín, thu mình và mất kết nối hoàn toàn với mẹ.<br />
  Lúc đó chị chỉ có một khao khát duy nhất là: Tìm lại đứa con từng vui vẻ, năng động như trước. Và chính trong khoảnh khắc ấy, chị biết đến cô Lanh và bắt đầu nhận ra rằng vấn đề hiện tại của mình không phải nằm ở con hay chồng, mà là chị có vấn đề với chính bản thân mình.
        `,
		videoSrc:
			"https://cdn.nguyenthilanh.com.vn/resources/landing-page/NGUYỄN THỊ THU HUYỀN.mp4",
		thumb: img5,
	},
	{
		title: "Mẹ áp đặt làm tổn thương con",
		description: `
          Khi bước vào độ tuổi dậy thì, con trai của chị Huyền Trang thường xuyên nóng nảy và khó kiểm soát cảm xúc, cũng như chưa chủ động trong học tập và cuộc sống. Điều này khiến chị lo lắng và băn khoăn không biết làm sao để có thể dẫn dắt con phát triển tốt hơn.<br />
  Trong quá trình tìm kiếm giải pháp, chị đã biết đến cô Lanh và tham gia vào các buổi chia sẻ của cô, nơi chị được lắng nghe những câu chuyện chuyển hóa đầy cảm hứng của các học viên khác. Không chỉ dừng lại ở đó, chị còn tham gia chương trình Kiến tạo offline, nơi chị thực hành các quy trình đầy quyền năng. Nhờ sự kiên nhẫn và đồng hành, mối quan hệ giữa hai mẹ con dần được cải thiện, con đã bình tĩnh hơn và có những thay đổi tích cực.<br />
  Hành trình của chị Huyền Trang không chỉ giúp con phát triển tốt hơn mà còn là nguồn động lực lớn cho những bậc cha mẹ đang tìm kiếm cách thức để dẫn dắt con cái một cách hiệu quả.
        `,
		videoSrc:
			"https://cdn.nguyenthilanh.com.vn/resources/landing-page/PHẠM HUYỀN TRANG.mp4",
		thumb: img6,
	},
	{
		title: "Ui mẹ mày đúng là người mẹ ao ước!",
		description: `
         "Ui mẹ mày đúng là người mẹ ao ước! - Con kể lại với mình như thế khi được bạn khen về mẹ, lúc đó mình rất vui và tự hào." - Chị Đạt chia sẻ.
Là một người mẹ đơn thân với ba con nhỏ, chị Đạt đã gặp không ít khó khăn trong hành trình nuôi dạy con, nhất là khi phải đảm nhiệm cả vai trò của cha lẫn mẹ. Khi các con ngày càng lớn, chị càng phải đối mặt với nhiều thách thức: các con trở nên lười học, thiếu tự giác, thường bị cuốn vào game và điện thoại. Mặc dù chị khuyên răn, nhắc nhở nhưng lời nói của chị không còn tác động nhiều, khiến chị càng thêm mệt mỏi và bất lực.
Trong quá trình tìm kiếm giải pháp, chị đã biết đến cô Lanh và tham gia các buổi chia sẻ của cô. Tại đây, chị được nghe những câu chuyện chuyển hóa đầy cảm hứng của các học viên khác. Không chỉ dừng lại ở đó, chị còn tham gia chương trình Kiến tạo offline, nơi chị thực hành các quy trình đầy quyền năng. Nhờ sự kiên nhẫn và đồng hành, mối quan hệ giữa mẹ con dần được cải thiện, các con bình tĩnh hơn và có những thay đổi tích cực.`,
		videoSrc:
			"https://cdn.nguyenthilanh.com.vn/resources/landing-page/TRỊNH THỊ ĐẠT.mp4",
		thumb: img7,
	},
];
const slideContentHighlight = [
	// Sửa SRC ở đây
	{
		title: "Chương Trình Kiến Tạo Cuộc Đời Mới Offline K8 - Đường Về Hạnh Phúc Tháng 3/2026",
		description: `
        ""
      `,
		videoSrc:
			"https://landing-page-assets.hcm.ss.bfcplatform.vn/KienTaoOff/Videos/kt-off-k8.mp4",
		thumb: thumbK8,
	},
	{
		title: "Chương Trình Kiến Tạo Cuộc Đời Mới Offline K7 - Đường Về Hạnh Phúc Tháng 10/2025",
		description: `
        ""
      `,
		videoSrc:
			"https://landing-page-assets.hcm.ss.bfcplatform.vn/KienTaoOff/Videos/kt-off-k7.mp4",
		thumb: thumbK7,
	},
	{
		title: "Chương Trình Kiến Tạo Cuộc Đời Mới Offline K6 - Đường Về Hạnh Phúc Tháng 8/2025",
		description: `
        ""
      `,
		videoSrc:
			"https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/videos/KTOFF-6.mp4",
		thumb: thumbK6,
	},
	{
		title: "Chương Trình Kiến Tạo Cuộc Đời Mới Offline K5 - Đường Về Hạnh Phúc Tháng 4/2025",
		description: `
        ""
      `,
		videoSrc:
			"https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/videos/Kien_Tao_Off_K6.mp4",
		thumb: thumbK5,
	},
	{
		title: "Chương Trình Kiến Tạo Cuộc Đời Mới Offline K4 - Đường Về Hạnh Phúc Tháng 1/2025",
		description: `
        ""
      `,
		videoSrc:
			"https://mtt-landing-page-assets.s3.ap-southeast-1.amazonaws.com/chuong-trinh-kien-tao-cuoc-doi-moi-offline-k4-duong-ve-hanh-phuc-thang-1-2025-nguyen-thi-lanh.mp4",
		thumb: thumbK4,
	},
	//
	{
		title: "Chương Trình Kiến Tạo Cuộc Đời Mới Offline K3 - Đường Về Hạnh Phúc tháng 10/2024",
		description: `
        ""
      `,
		videoSrc:
			"https://cdn.nguyenthilanh.com.vn/resources/landing-page/Chương Trình Kiến Tạo Cuộc Đời Mới Offline K3 - Đường Về Hạnh Phúc tháng 10_2024.mp4",
		thumb: thumbK3,
	},
	{
		title: "Chương Trình Kiến Tạo Cuộc Đời Mới Offline K2 - Đường Về Hạnh Phúc tháng 7/2024",
		description: `
        ""
      `,
		videoSrc:
			"https://cdn.nguyenthilanh.com.vn/resources/landing-page/Chương Trình Kiến Tạo Cuộc Đời Mới Offline K2 - Đường Về Hạnh Phúc tháng 7_2024.mp4",
		thumb: thumbK2,
	},
	{
		title: "Chương Trình Kiến Tạo Cuộc Đời Mới Offline K1 - Đường Về Hạnh Phúc tháng 3/2024",
		description: `
        ""
      `,
		videoSrc:
			"https://cdn.nguyenthilanh.com.vn/resources/landing-page/Chương Trình Kiến Tạo Cuộc Đời Mới Offline K1 - Đường Về Hạnh Phúc tháng 3_2024.mp4",
		thumb: thumbK1,
	},
];

const swiperWrapper = document.querySelector(".swiper-wrapper-experience");
document.addEventListener("DOMContentLoaded", () => {
	const initialContent = slideContentExperience[0];
	document.getElementById("slide-title").textContent = initialContent.title;
	document.getElementById("slide-description").innerHTML =
		initialContent.description;
	document.getElementById("slide-bg").style.backgroundImage =
		`url(${initialContent.thumb})`;
});
let selectSlideIndex = 0;
let selectSlideIndex2 = 0;
const swiper = new Swiper(".swiper1", {
	spaceBetween: 20,
	loop: true,

	on: {
		slideChange: (swiper) => console.log(swiper, "1688"),
		slideNextTransitionEnd: function () {
			selectSlideIndex++;
			const activeContent =
				slideContentExperience[
					selectSlideIndex % slideContentExperience.length
				];

			document.getElementById("slide-bg").style.backgroundImage =
				`url(${activeContent.thumb})`;
			document.getElementById("slide-title").textContent =
				activeContent.title;

			document.getElementById("slide-description").innerHTML =
				activeContent.description;
			document.getElementById("videoPlayer2").src =
				activeContent.videoSrc;
		},
		slidePrevTransitionEnd: function () {
			selectSlideIndex--;
			const activeContent =
				slideContentExperience[
					selectSlideIndex % slideContentExperience.length
				];

			document.getElementById("slide-bg").style.backgroundImage =
				`url(${activeContent.thumb})`;
			document.getElementById("slide-title").textContent =
				activeContent.title;

			document.getElementById("slide-description").innerHTML =
				activeContent.description;
			document.getElementById("videoPlayer2").src =
				activeContent.videoSrc;
		},
	},
	navigation: {
		nextEl: ".my-swiper-button-next",
		prevEl: ".my-swiper-button-prev",
	},
	breakpoints: {
		1024: {
			slidesPerView: 4,
		},
		0: {
			slidesPerView: 1,
		},
	},
	speed: 600, // Transition speed
});
const openVideoBtn2 = document.getElementById("openVideoBtn2");
function openVideoExperience() {
	videoPlayer.play().catch((error) => {
		console.error("Video auto-play failed:", error);
	});

	modal2.classList.remove("hidden");
}
openVideoBtn2.addEventListener("click", openVideoExperience);
slideContentExperience.forEach((slide, index) => {
	const slideDiv = document.createElement("div");
	slideDiv.className = "swiper-slide";

	slideDiv.innerHTML = `
  <div class="flex flex-col items-center overflow-hidden w-full">
    <div data-target-index="${index}" class="w-full h-[220px] rounded-lg cursor-pointer img-experience bg-cover bg-no-repeat" style="background-image: url('${slide.thumb}');">

    </div>
    <div class="px-4 py-2 text-center text-sm lg:text-base font-semibold text-[#fafafa]">
      ${slide.title}
    </div>
  </div>
  `;
	slideDiv.addEventListener("click", (event) => {
		const targetDiv = event.target.closest(".img-experience");
		if (targetDiv) {
			const dataIndex = targetDiv.getAttribute("data-target-index");
			const activeIndex = dataIndex;
			const activeContent =
				slideContentExperience[
					activeIndex % slideContentExperience.length
				];

			document.getElementById("slide-bg").style.backgroundImage =
				`url(${activeContent.thumb})`;
			document.getElementById("slide-title").textContent =
				activeContent.title;

			document.getElementById("slide-description").innerHTML =
				activeContent.description;

			document.getElementById("videoPlayer2").src =
				activeContent.videoSrc;
			openVideoExperience();
		}
	});
	swiperWrapper.appendChild(slideDiv);
});

const swiperHighLight = new Swiper(".swiper2", {
	spaceBetween: 20,
	loop: true,
	on: {
		slideNextTransitionEnd: function () {
			selectSlideIndex2++;
			const activeContent =
				slideContentHighlight[
					selectSlideIndex2 % slideContentHighlight.length
				];

			document.getElementById(
				"slide-bg-highlight",
			).style.backgroundImage = `url(${activeContent.thumb})`;
			document.getElementById("slide-title-highlight").textContent =
				activeContent.title;

			document.getElementById("videoPlayer2").src =
				activeContent.videoSrc;
		},
		slidePrevTransitionEnd: function () {
			selectSlideIndex2--;
			const activeContent =
				slideContentHighlight[
					selectSlideIndex2 % slideContentHighlight.length
				];

			document.getElementById(
				"slide-bg-highlight",
			).style.backgroundImage = `url(${activeContent.thumb})`;
			document.getElementById("slide-title-hightlight").textContent =
				activeContent.title;

			document.getElementById("videoPlayer2").src =
				activeContent.videoSrc;
		},
	},
	navigation: {
		nextEl: ".my-swiper-button-next-highlight",
		prevEl: ".my-swiper-button-prev-highlight",
	},
	breakpoints: {
		1024: {
			slidesPerView: 3,
		},

		0: {
			slidesPerView: 1,
		},
	},
	autoplay: false,
	speed: 600,
});
const modal2 = document.getElementById("videoModal2");

const openVideoBtnHighlight = document.getElementById("openVideoBtnHighlight");
const videoPlayer = document.getElementById("videoPlayer2");

const closeVideoBtn2 = document.getElementById("closeVideoBtn2");
function openVideoHighlight() {
	videoPlayer.play().catch((error) => {
		console.error("Video auto-play failed:", error);
	});

	modal2.classList.remove("hidden");
}
openVideoBtnHighlight.addEventListener("click", openVideoHighlight);

closeVideoBtn2.addEventListener("click", () => {
	// Pause the video and clear the source when closing
	videoPlayer.pause();

	// Hide the modal
	modal2.classList.add("hidden");
});

const swiperWrapperHighlight = document.querySelector(
	".swiper-wrapper-highlight",
);

slideContentHighlight.forEach((slide, index) => {
	const slideDiv = document.createElement("div");
	slideDiv.className = "swiper-slide";

	slideDiv.innerHTML = `
  <div class="flex flex-col items-center overflow-hidden w-full">
    <div data-target-index=${index} class="w-full h-[250px] rounded-lg cursor-pointer bg-cover img-highlight bg-no-repeat" style="background-image: url('${slide.thumb}');">

    </div>
    <div class="px-4 py-2 text-center text-sm lg:text-base font-semibold text-[#fafafa]">
      ${slide.title}
    </div>
  </div>
`;

	// slideDiv.addEventListener("click", () => {
	//   swiperHighLight.slideTo(index);
	// });
	slideDiv.addEventListener("click", (event) => {
		const targetDiv = event.target.closest(".img-highlight");
		if (targetDiv) {
			const dataIndex = targetDiv.getAttribute("data-target-index");
			const activeIndex = dataIndex;
			const activeContent = slideContentHighlight[activeIndex];
			document.getElementById(
				"slide-bg-highlight",
			).style.backgroundImage = `url(${activeContent.thumb})`;
			document.getElementById("slide-title-highlight").textContent =
				activeContent.title;

			document.getElementById("videoPlayer2").src =
				activeContent.videoSrc;
			openVideoHighlight();
		}
	});
	swiperWrapperHighlight.appendChild(slideDiv);
});

function changeExperienceTab(tab) {
	const experienceContentElement =
		document.getElementById("experience-content");
	const highlightContentElement =
		document.getElementById("highlight-content");

	const experienceTab = document.getElementById("experience-tab");
	const highlightTab = document.getElementById("highlight-tab");

	if (tab === "experience") {
		experienceContentElement.classList.remove("hidden");
		highlightContentElement.classList.add("hidden");

		experienceTab.classList.add("active-tab");
		experienceTab.classList.remove("inactive-tab");
		highlightTab.classList.add("inactive-tab");
		highlightTab.classList.remove("active-tab");
	} else {
		const initialContent = slideContentHighlight[0];
		document.getElementById("slide-title-highlight").textContent =
			initialContent.title;

		document.getElementById("slide-bg-highlight").style.backgroundImage =
			`url(${initialContent.thumb})`;
		document.getElementById("videoPlayer2").src = initialContent.videoSrc;

		experienceContentElement.classList.add("hidden");
		highlightContentElement.classList.remove("hidden");

		highlightTab.classList.add("active-tab");
		highlightTab.classList.remove("inactive-tab");
		experienceTab.classList.add("inactive-tab");
		experienceTab.classList.remove("active-tab");
	}
}

window.changeExperienceTab = changeExperienceTab;
